import type { CameraApiResponse } from "@src/services/api/cameras-api";
import { formatCameraLabel } from "@src/utils/key-parser";

export function normalizeCameraNickname(nickname: string | null | undefined): string | null {
  const trimmed = nickname?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : null;
}

export function resolveCameraDisplayName(cameraKey: string, nickname: string | null | undefined): string {
  return normalizeCameraNickname(nickname) ?? formatCameraLabel(cameraKey);
}

/**
 * What to call a camera in a list built from the tenant-wide camera search.
 *
 * The customer's nickname reaches the client under two different names: the
 * single-camera endpoint returns `provisioned.friendlyName` as `nickname`,
 * while the search endpoint returns the same field as `name`. A list fed by
 * the search therefore has to read `name` as well, or every camera falls back
 * to its formatted key and the nickname never shows.
 */
export function resolveCameraName(camera: Pick<CameraApiResponse, "nickname" | "name">, cameraKey: string): string {
  return (
    normalizeCameraNickname(camera.nickname) ?? normalizeCameraNickname(camera.name) ?? formatCameraLabel(cameraKey)
  );
}
